import { Component, HostBinding } from "@angular/core";
import { environment } from "environments/environment";

@Component({
  moduleId: module.id,
  selector: "footer-cmp",
  templateUrl: "footer.component.html",
})
export class FooterComponent {
  test: Date = new Date();
  developedBy: any;
  constructor() {
    if (JSON.parse(localStorage.getItem("client"))) {
      const clientDetails = JSON.parse(localStorage.getItem("client"));
      if (clientDetails["name"] === "saahaaz") {
        this.developedBy = false;
      } else {
        this.developedBy = environment.showDevelopedBy;
      }
    }
  }
}
